export { default } from './part-banner-main';
